(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/pay-numbergames/assets/javascripts/dialogs/confirm-payment-content.js') >= 0) return;  svs.modules.push('/components/numbergames/pay-numbergames/assets/javascripts/dialogs/confirm-payment-content.js');

'use strict';

const productMapping = svs.numbergames.productMapping;
const drawsUtils = svs.numbergames.draws.drawsUtils;
const sortOrder = ['måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag', 'söndag'];
const getWeekDay = date => {
  switch (true) {
    case dateFns.isToday(date):
      return 'idag';
    case dateFns.isTomorrow(date):
      return 'imorgon';
    default:
      return svs.utils.date.getLocalizedWeekday(date, false, true);
  }
};
const shortDate = date => svs.utils.date.ShortDateAndTime(date, true, false);
const drawDateDescription = wagers => {
  const products = wagers.map(w => w.bets[0].productId);
  const numDraws = wagers[0].bets[0].numDraws;
  const dates = products.map(product => getWeekDay(drawsUtils.firstDrawDate(product))).join(' och ');
  if (numDraws > 1) {
    const weekdays = products.map(product => "".concat(productMapping.getDay(product).toLowerCase(), "ar")).join(' och ');
    const dates = "".concat(shortDate(drawsUtils.firstDrawDate(products)), "\xA0-\xA0").concat(shortDate(drawsUtils.lastDrawDate(products, {
      drawCount: numDraws
    })));
    return "Spell\xE4ngd: ".concat(numDraws, " veckor, ").concat(weekdays, " ").concat(dates);
  }
  if (wagers.length > 1) {
    return "Spell\xE4ngd: 1 vecka, ".concat(dates);
  }
  return "Spell\xE4ngd: 1 dag, ".concat(dates);
};
const productsDescription = (product, wagers) => {
  const hasJoker = wagers[0].bets.some(b => productMapping.isJoker(b.productId));
  const jokerStr = productMapping.isVikinglotto(product) && hasJoker ? 'med Joker' : '';
  return "".concat(productMapping.getProductName(product), " ").concat(jokerStr, " ").concat(productMapping.isProductFamily(product) ? wagers.map(_ref => {
    let bets = _ref.bets;
    return productMapping.getDay(bets[0].productId).toLowerCase();
  }).sort((a, b) => sortOrder.indexOf(a) - sortOrder.indexOf(b)).join(' och ') : '').trim();
};
function payAfterDeposit() {
  const payAfterDeposit = svs.utils.paramHandler.get({
    key: 'afterpay'
  }).value;
  svs.utils.paramHandler.remove({
    key: 'afterpay'
  });
  return payAfterDeposit;
}
const confirmPaymentTitle = _ref2 => {
  let product = _ref2.product,
    wagers = _ref2.wagers,
    price = _ref2.price,
    isSyndicate = _ref2.isSyndicate,
    ticket = _ref2.ticket;
  let ticketText = '';
  if (ticket) {
    ticketText = "och ".concat(ticket.length > 1 ? ticket.length : 'en', " Triss ");
  }
  return "".concat(payAfterDeposit() ? 'Din insättning är klar.<br>' : '', "Vill du betala ett ").concat(isSyndicate ? 'lagspel' : 'spel', " p\xE5 ").concat(productsDescription(product, wagers), " ").concat(ticketText, "f\xF6r ").concat(price, "&nbsp;kr?");
};
const confirmPaymentMessages = (wagers, product) => {
  const hasJoker = wagers[0].bets.some(b => productMapping.isJoker(b.productId));
  const jokerStr = productMapping.isVikinglotto(product) && hasJoker ? 'med Joker' : '';
  const messages = ["".concat(productMapping.getProductName(product), " ").concat(jokerStr, " g\xE5r att annullera.")];
  const productId = productMapping.getProductId(wagers[0].bets[0].productId);
  if (!productMapping.isKeno(productId)) {
    messages.unshift(drawDateDescription(wagers));
  }
  return messages;
};
Object.assign(svs.numbergames.pay_numbergames, {
  confirmPaymentTitle,
  confirmPaymentMessages
});

 })(window);